import * as React from 'react';
import { connect } from 'react-redux';
import { IUserProfile } from '../Auth/types';
import Constants from '../../core/libraries/Constants';
import { INavLink, Nav, IconButton, IIconProps } from '@fluentui/react';
import { RootState } from '../../store/store';

interface AdminWrapperProps {
    userProfile: IUserProfile | undefined;
    history: any;
    children: any;
}

interface AdminWrapperState {
    isMinimized: boolean;
}

class AdminWrapper extends React.Component<AdminWrapperProps, AdminWrapperState> {

    constructor(props: AdminWrapperProps) {
        super(props);
        // Initialize state from localStorage
        const savedState = localStorage.getItem('admin-sidebar-minimized');
        this.state = {
            isMinimized: savedState ? JSON.parse(savedState) : false
        };
        this.renderSideBar = this.renderSideBar.bind(this);
        this.toggleSidebar = this.toggleSidebar.bind(this);
    }

    toggleSidebar = () => {
        this.setState(prevState => {
            const newMinimizedState = !prevState.isMinimized;
            // Save to localStorage
            localStorage.setItem('admin-sidebar-minimized', JSON.stringify(newMinimizedState));
            return {
                isMinimized: newMinimizedState
            };
        });
    }

    render() {
        let element: any = "";
        if (this.props.userProfile?.permissions?.checkHasPermission([Constants.PERMISSIONS.ADMIN])) {
            element = (
                <div className="ms-Grid">
                    <div className="ms-Grid-row">
                        <div
                            className="ms-Grid-col"
                            style={{
                                width: this.state.isMinimized ? '60px' : '200px',
                                transition: 'width 0.3s ease',
                                minWidth: this.state.isMinimized ? '60px' : '200px',
                                maxWidth: this.state.isMinimized ? '60px' : '200px'
                            }}
                        >
                            {this.renderSideBar()}
                        </div>
                        <div
                            className="ms-Grid-col"
                            style={{
                                width: this.state.isMinimized ? 'calc(100% - 60px)' : 'calc(100% - 200px)',
                                transition: 'width 0.3s ease'
                            }}
                        >
                            {this.props.children}
                        </div>
                    </div>
                </div>
            );
        }
        return element;
    }

    handleClickNavLink = (event: React.MouseEvent, url: string) => {
        event.preventDefault();
        this.props.history.push(url)
    }

    getNavIcon = (name: string): string => {
        const iconMap: { [key: string]: string } = {
            "Statistics": "BarChart4",
            "Move": "Move",
            "Grant Access": "Permissions",
            "Departments": "Group",
            "Notification Bar": "Ringer",
            "Administrative Action Tracker": "ActivityFeed",
            "Application Setting": "Settings"
        };
        return iconMap[name] || "Circle";
    }

    renderSideBar() {
        let options: INavLink[] = [];

        // Statistics
        if (this.props.userProfile?.permissions?.checkHasPermission([Constants.PERMISSIONS.ADMIN])) {
            options.push({
                name: "Statistics",
                url: process.env.REACT_APP_STATISTICS!,
                icon: this.getNavIcon("Statistics"),
                onClick: (e) => { this.handleClickNavLink(e!, process.env.REACT_APP_STATISTICS!) }
            });
        }

        // Move
        if (this.props.userProfile?.permissions?.checkHasPermission([Constants.PERMISSIONS.ADMIN])) {
            options.push({
                name: "Move",
                url: process.env.REACT_APP_MOVE!,
                icon: this.getNavIcon("Move"),
                onClick: (e) => { this.handleClickNavLink(e!, process.env.REACT_APP_MOVE!) }
            });
        }

        // Grant Access
        if (this.props.userProfile?.permissions?.checkHasPermission([Constants.PERMISSIONS.SUPER_ADMIN,
        Constants.PERMISSIONS.RND_DIVISION_ADMIN, Constants.PERMISSIONS.THESIS_ADMIN])) {
            options.push({
                name: "Grant Access",
                url: process.env.REACT_APP_GRANT_ACCESS!,
                icon: this.getNavIcon("Grant Access"),
                onClick: (e) => { this.handleClickNavLink(e!, process.env.REACT_APP_GRANT_ACCESS!) }
            });
        }

        if (this.props.userProfile?.permissions?.checkHasPermission([Constants.PERMISSIONS.SUPER_ADMIN])) {
            // Departments
            options.push({
                name: "Departments",
                url: process.env.REACT_APP_DEPARTMENTS!,
                icon: this.getNavIcon("Departments"),
                onClick: (e) => { this.handleClickNavLink(e!, process.env.REACT_APP_DEPARTMENTS!) }
            });

            options.push({
                name: "Notification Bar",
                url: process.env.REACT_APP_NOTIFICATION_BAR!,
                icon: this.getNavIcon("Notification Bar"),
                onClick: (e) => { this.handleClickNavLink(e!, process.env.REACT_APP_NOTIFICATION_BAR!) }
            });


        }

        if (this.props.userProfile?.permissions?.checkHasPermission([Constants.PERMISSIONS.CONFIGURATION])) {
            options.push({
                name: "Application Setting",
                url: process.env.REACT_APP_APP_SETTING!,
                icon: this.getNavIcon("Application Setting"),
                onClick: (e) => { this.handleClickNavLink(e!, process.env.REACT_APP_APP_SETTING!) }
            });
        }

        const toggleIcon: IIconProps = {
            iconName: this.state.isMinimized ? 'DoubleChevronRight' : 'DoubleChevronLeft'
        };

        return (
            <div className="ms-Grid" style={{ position: 'relative', height: '100%' }}>
                {/* Toggle Button */}
                <div style={{
                    position: 'absolute',
                    top: '10px',
                    right: '10px',
                    zIndex: 1000
                }}>
                    <IconButton
                        iconProps={toggleIcon}
                        title={this.state.isMinimized ? 'Expand sidebar' : 'Collapse sidebar'}
                        onClick={this.toggleSidebar}
                        styles={{
                            root: {
                                backgroundColor: '#f3f2f1',
                                borderRadius: '4px',
                                width: '32px',
                                height: '32px'
                            }
                        }}
                    />
                </div>

                <div className="ms-Grid-row management-title">
                    <Nav
                        styles={{
                            root: {
                                width: "100%",
                                height: "calc(100vh - 140px)",
                                boxSizing: 'border-box',
                                borderRight: '1px solid #eee',
                                overflowY: 'auto',
                                paddingTop: '50px',
                                backgroundColor: '#fafafa'
                            },
                            link: {
                                color: "black",
                                ...(this.state.isMinimized && {
                                    justifyContent: 'center',
                                    paddingLeft: '8px',
                                    paddingRight: '8px',
                                    minHeight: '44px'
                                })
                            },
                            linkText: {
                                ...(this.state.isMinimized && {
                                    display: 'none'
                                })
                            },
                            compositeLink: {
                                ...(this.state.isMinimized && {
                                    justifyContent: 'center'
                                })
                            }
                        }}
                        groups={[{
                            links: options
                        }]}
                    />
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: RootState) => ({
    userProfile: state.auth.userProfile
});

export default connect(mapStateToProps)(AdminWrapper);